import { render, staticRenderFns } from "./exportTip.vue?vue&type=template&id=2e8c4b6e&scoped=true"
import script from "./exportTip.vue?vue&type=script&lang=js"
export * from "./exportTip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8c4b6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e8c4b6e')) {
      api.createRecord('2e8c4b6e', component.options)
    } else {
      api.reload('2e8c4b6e', component.options)
    }
    module.hot.accept("./exportTip.vue?vue&type=template&id=2e8c4b6e&scoped=true", function () {
      api.rerender('2e8c4b6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Problem/problemList/component/exportTip.vue"
export default component.exports